exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".room[data-v-15fe2cf8]{border:1px solid rgba(0,0,0,.38);border-radius:8px;margin-bottom:2rem;padding:16px}", ""]);

// exports
